function migrateToShop443(state: any) {
  return { ...state, insuranceNumber: { errors: [], valid: false } };
}

export default migrateToShop443;
